module.exports = __webpack_public_path__ + "static/img/zaozhuang-index.eaa122f4.jpg";